import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export function BathsSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <g clipPath="url(#clip0_5004_29)">
        <path d="M4.78125 12V14.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.2188 12V14.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.2812 6H9.03125V10.25H13.2812V6Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M13.2812 6.5H15.9375V9.56818C15.9375 10.5447 15.6017 11.4811 15.0039 12.1716C14.4061 12.8621 13.5954 13.25 12.75 13.25H4.25C3.40462 13.25 2.59387 12.8621 1.9961 12.1716C1.39832 11.4811 1.0625 10.5447 1.0625 9.56818V6.5H9.03125"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.71875 7.75V3.59723C3.71875 3.17362 3.85868 2.76736 4.10775 2.46782C4.35682 2.16828 4.69463 2 5.04688 2C5.35618 1.99913 5.65646 2.12533 5.89799 2.3577C6.13952 2.59007 6.30781 2.91468 6.375 3.27778"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5004_29">
          <rect width="17" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
